export const PERMISSIONS = {
  CONTENT: {
    CREATE: 'content.c',
    READ: 'content.r',
    UPDATE: 'content.u',
    DELETE: 'content.d',
  },
  ARTIST: {
    CREATE: 'artist.c',
    READ: 'artist.r',
    UPDATE: 'artist.u',
    DELETE: 'artist.d',
  },
  VENUE: {
    CREATE: 'venue.c',
    READ: 'venue.r',
    UPDATE: 'venue.u',
    DELETE: 'venue.d',
  },
  WEBSITE: {
    CREATE: 'website.c',
    READ: 'website.r',
    UPDATE: 'website.u',
    DELETE: 'website.d',
  },
  PRICING: {
    CREATE: 'pricing.c',
    READ: 'pricing.r',
    UPDATE: 'pricing.u',
    DELETE: 'pricing.d',
  },
  PAYMENT_GATEWAY: {
    CREATE: 'payment_gateway.c',
    READ: 'payment_gateway.r',
    UPDATE: 'payment_gateway.u',
    DELETE: 'payment_gateway.d',
  },
  META_DATA: {
    CREATE: 'meta_data.c',
    READ: 'meta_data.r',
    UPDATE: 'meta_data.u',
    DELETE: 'meta_data.d',
  },
  DISCOUNT: {
    CREATE: 'discount.c',
    READ: 'discount.r',
    UPDATE: 'discount.u',
    DELETE: 'discount.d',
  },
  USER_MANAGEMENT: {
    CREATE: 'user_management.c',
    READ: 'user_management.r',
    UPDATE: 'user_management.u',
    DELETE: 'user_management.d',
  },
  ACCOUNT_MANAGEMENT: {
    CREATE: 'account_management.c',
    READ: 'account_management.r',
    UPDATE: 'account_management.u',
    DELETE: 'account_management.d',
  },
  AFFILIATES: {
    CREATE: 'affiliates.c',
    READ: 'affiliates.r',
    UPDATE: 'affiliates.u',
    DELETE: 'affiliates.d',
  },
  CONTENT_PARTNER: {
    CREATE: 'content_partner.c',
    READ: 'content_partner.r',
    UPDATE: 'content_partner.u',
    DELETE: 'content_partner.d',
  },
  LIVE: {
    CREATE: 'live.c',
    READ: 'live.r',
    UPDATE: 'live.u',
    DELETE: 'live.d',
  },
  ANALYTICS: {
    CREATE: 'analytics.c',
    READ: 'analytics.r',
    UPDATE: 'analytics.u',
    DELETE: 'analytics.d',
  },
  MOBILE_APP: {
    CREATE: 'mobile_app.c',
    READ: 'mobile_app.r',
    UPDATE: 'mobile_app.u',
    DELETE: 'mobile_app.d',
  },
  TV_APP: {
    CREATE: 'tv_app.c',
    READ: 'tv_app.r',
    UPDATE: 'tv_app.u',
    DELETE: 'tv_app.d',
  },
  EMAIL_TEMPLATE: {
    CREATE: 'email_template.c',
    READ: 'email_template.r',
    UPDATE: 'email_template.u',
    DELETE: 'email_template.d',
  },
  CUSTOM_FORMS: {
    CREATE: 'custom_forms.c',
    READ: 'custom_forms.r',
    UPDATE: 'custom_forms.u',
    DELETE: 'custom_forms.d',
  },
  CAMPAIGN_MARKETING: {
    CREATE: 'campaign_marketing.c',
    READ: 'campaign_marketing.r',
    UPDATE: 'campaign_marketing.u',
    DELETE: 'campaign_marketing.d',
  },
  IPTV_MODULE: {
    CREATE: 'iptv_module.c',
    READ: 'iptv_module.r',
    UPDATE: 'iptv_module.u',
    DELETE: 'iptv_module.d',
  },
}
